import React from "react";
import { Container, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";

function Home() {
  return (
    <Container style={{ textAlign: "center", marginTop: "50px" }}>
      <Typography variant="h3" gutterBottom>
        👋 Hi, I'm Chetan Kerhalkar!
      </Typography>
      <Typography variant="h5" gutterBottom>
        Technology Director | AI/ML Specialist | VIBE Coder
      </Typography>
      <Typography variant="body1" gutterBottom>
        🎓 Certified Microsoft Azure Solution Architect & Azure AI Engineer Associate
      </Typography>
      <Typography variant="body1" gutterBottom>
        🚀 Expert in Generative AI, Microservices, ReactJS, .NET, and Cloud-Native Architectures
      </Typography>
      <Button
        variant="contained"
        color="primary"
        component={Link}
        to="/projects"
        style={{ marginTop: "20px" }}
      >
        View My Projects
      </Button>
    </Container>
  );
}

export default Home;